import React, { useCallback, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import 'moment/locale/ja'
import moment from 'moment'
import { db, functions } from '../../firebase/index'
import { makeStyles } from '@material-ui/styles'
import {
  Container,
  CssBaseline,
  Typography,
  Button,
  List,
  Card,
  CardContent,
  CardActions,
  Paper,
  TextField,
  FormControl,
  Radio,
  FormControlLabel,
  RadioGroup,
  ListItem,
  ListItemIcon,
  Checkbox,
  ListItemText,
} from '@material-ui/core'

import PhoneIcon from '@material-ui/icons/Phone'
import MapIcon from '@material-ui/icons/Map'

import { saveRequest } from '../../modules/app'

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  webbooks: {
    maxHeight: 300,
    overflow: 'auto',
  },
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 300,
  },
  card: {
    marginTop: theme.spacing(2),
    width: '100%',
  },
  cardAction: {
    justifyContent: 'center',
  },
  listSection: {
    backgroundColor: 'inherit',
  },
  ul: {
    backgroundColor: 'inherit',
    padding: 0,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  tel: { textDecoration: 'none' },
}))

const Normal = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  let id = window.location.pathname.split('/webbooks/basic')[1]
  if (id !== '') {
    id = id.split('/')[1]
  } else {
    dispatch(push('/'))
  }

  const [accountId, setAccountId] = useState('')
  const [bookId, setBookId] = useState('')
  const [name, setName] = useState('')
  const [url, setUrl] = useState('')
  const [token, setToken] = useState('')
  const [cardTitle, setCardTitle] = useState('')
  const [cardBody, setCardBody] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [address, setAddress] = useState('')
  const [biko, setBiko] = useState('')
  const [books, setBooks] = useState([])
  const [mailSubject, setMailSubject] = useState('')
  const [mailText, setMailText] = useState('')
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)

  const [selectedDate, setSelectedDate] = useState('')
  const [patName, setPatName] = useState('')
  const [patPhone, setPatPhone] = useState('')
  const [patEmail, setPatEmail] = useState('')

  const [checked, setChecked] = useState([])

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value)
    const newChecked = [...checked]

    if (currentIndex === -1) {
      newChecked.push(value)
    } else {
      newChecked.splice(currentIndex, 1)
    }

    setChecked(newChecked)
  }

  const inputPatPhone = useCallback(
    (event) => {
      setPatPhone(event.target.value)
    },
    [setPatPhone]
  )

  const inputPatEmail = useCallback(
    (event) => {
      setPatEmail(event.target.value)
    },
    [setPatEmail]
  )

  const inputPatName = useCallback(
    (event) => {
      setPatName(event.target.value)
    },
    [setPatName]
  )

  const inputBiko = useCallback(
    (event) => {
      setBiko(event.target.value)
    },
    [setBiko]
  )

  const handleChange = (event) => {
    setSelectedDate(event.target.value)
    setBookId(event.target.name)
  }

  useEffect(() => {
    setLoading(true)
    if (id !== '') {
      db.collection('accounts')
        .doc(id)
        .get()
        .then((res) => {
          const data = res.data()
          if (data) {
            setAccountId(data.id)
            setName(data.name)
            setEmail(data.email)
            setPhone(data.phone)
            setAddress(data.address)
            setCardBody(data.cardBody)
            setCardTitle(data.cardTitle)
            setMailSubject(data.mailSubject)
            setMailText(data.mailText)
            setUrl(data.url)
            setToken(data.token)
            setList(data.list)

            fetch(`${data.url}?limit=${data.limit}`, {
              headers: {
                Authorization: data.token,
              },
            })
              .then((res) => res.json())
              .then((books) => {
                console.log(books)
                books.slice(0, data.limit).map((book) => setBooks((d) => [...d, book]))
                setLoading(false)
              })
          }
        })
    }
  }, [id])

  return (
    <div>
      {loading ? (
        <div>Loading...</div>
      ) : (
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div className={classes.paper}>
            <Card className={classes.card}>
              <CardContent>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                  {cardTitle}
                </Typography>
                <Typography variant="h5" component="h2">
                  {name}
                </Typography>
                <pre style={{ fontFamily: 'inherit' }}>{cardBody}</pre>
              </CardContent>
              <CardActions className={classes.cardAction}>
                <a href={`tel:${phone.replace(/-/g, '')}`} className={classes.tel}>
                  <Button variant="contained" startIcon={<PhoneIcon />}>
                    電話をかける
                  </Button>
                </a>
                <Button
                  variant="contained"
                  startIcon={<MapIcon />}
                  onClick={() =>
                    window.open(`https://maps.google.co.jp/maps?q=${encodeURIComponent(address)}`)
                  }
                >
                  地図を確認
                </Button>
              </CardActions>
            </Card>
            <Card className={classes.card}>
              <CardContent>
                <Typography>希望の予約日、時間を選択してください</Typography>
              </CardContent>

              <Paper className={classes.webbooks}>
                <FormControl>
                  <RadioGroup name="webbooks" value={selectedDate} onChange={handleChange}>
                    {books.map((book) => (
                      <FormControlLabel
                        key={book.id}
                        name={book.id}
                        value={book.start}
                        control={<Radio />}
                        label={`${moment(book.start).format('M月D日HH時mm分(ddd)')} - ${moment(
                          book.end
                        ).diff(moment(book.start), 'minutes')} 分`}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Paper>
            </Card>

            <Card className={classes.card}>
              <CardContent>
                <Typography>現在の症状、お悩みをお選びください</Typography>
                <div>複数選択可能</div>
              </CardContent>
              <List>
                {list.map((value) => {
                  const labelId = `checkbox-list-label-${value}`
                  return (
                    <ListItem
                      key={value}
                      role={undefined}
                      dense
                      button
                      onClick={handleToggle(value)}
                    >
                      <ListItemIcon>
                        <Checkbox
                          edge="start"
                          checked={checked.indexOf(value) !== -1}
                          tabIndex={-1}
                          disableRipple
                          inputProps={{ 'aria-labelledby': labelId }}
                        />
                      </ListItemIcon>
                      <ListItemText id={labelId} primary={`${value}`} />
                    </ListItem>
                  )
                })}
              </List>
            </Card>

            <Card className={classes.card}>
              <CardContent>
                <Typography>受診者について</Typography>
                <div>実際に診療される方の情報を記載ください</div>
                <TextField
                  margin="dense"
                  fullWidth
                  label="お名前"
                  required
                  type="text"
                  value={patName}
                  onChange={inputPatName}
                />
                <TextField
                  margin="dense"
                  fullWidth
                  label="電話番号"
                  required
                  type="text"
                  value={patPhone}
                  onChange={inputPatPhone}
                />
                <TextField
                  margin="dense"
                  fullWidth
                  label="Eメールアドレス"
                  required
                  type="text"
                  value={patEmail}
                  onChange={inputPatEmail}
                />
              </CardContent>
            </Card>

            <Card className={classes.card}>
              <CardContent>
                <Typography>その他、ご希望あれば入力してください</Typography>
                <div>ご紹介がある場合、担当医変更希望など</div>
                <TextField
                  margin="dense"
                  fullWidth
                  label="その他"
                  multiline
                  rows={5}
                  type="text"
                  value={biko}
                  onChange={inputBiko}
                />
              </CardContent>
            </Card>

            <Button
              className={classes.submit}
              variant="contained"
              color="primary"
              onClick={() => {
                dispatch(
                  saveRequest(accountId, patName, patPhone, patEmail, selectedDate, biko)
                ).then((re) => {
                  if (re) {
                    fetch(`${url}/${bookId}`, {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                        Authorization: token,
                      },
                      body: JSON.stringify({
                        name: patName,
                        phone: patPhone,
                        email: patEmail,
                        memo: `${biko} ${checked.join()}`,
                      }),
                    })

                    const sendMail = functions.httpsCallable('sendMail')
                    const body = mailText
                      .replace(/{{name}}/g, patName)
                      .replace(/{{date}}/g, moment(selectedDate).format('YYYY-MM-DD HH:mm'))
                    sendMail({
                      to: patEmail,
                      subject: mailSubject,
                      text: body,
                    })
                      .then(() => {
                        console.log('ok')
                      })
                      .catch((error) => {
                        throw new Error(error)
                      })

                    const subject = 'WEB予約通知'
                    const text =
                      `希望日時:${moment(selectedDate).format('YYYY-MM-DD HH:mm')}\n` +
                      `お名前:${patName}\n` +
                      `電話番号:${patPhone}\n` +
                      `メールアドレス:${patEmail}\n` +
                      `現在の症状:${checked.join()}\n` +
                      `その他:${biko}\n`
                    const msg = {
                      to: email,
                      subject: subject,
                      text: text,
                    }
                    sendMail(msg)
                      .then(() => {
                        dispatch(push('/sent'))
                      })
                      .catch((error) => {
                        throw new Error(error)
                      })
                  }
                })
              }}
            >
              仮予約を登録
            </Button>
          </div>
        </Container>
      )}
    </div>
  )
}

export default Normal
